<template>
  <div id="cadastre" class="page-container" :style="{ 'backgroundImage': 'url(\'' + bg_image + '\')' }">

          <div class="box w-660px pull-right">
              <h1 class="m-t-60">Cadastre-se para receber o cupom de desconto</h1>
              <div>
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                  <b-form-group id="input-group-2">
                    <b-form-input
                      id="nome"
                      v-model="form.nome"
                      maxlength="50"
                      required
                      placeholder="Nome"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group id="input-group-cep">
                    <b-form-input
                      id="cep"
                      v-model="form.cep"
                      maxlength="9"
                      required
                      placeholder="CEP"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group id="input-group-email">
                    <b-form-input
                      id="email"
                      v-model="form.email"
                      maxlength="50"
                      type="email"
                      required
                      placeholder="E-mail"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group id="input-group-telefone">
                    <b-form-input
                      id="telefone"
                      v-model="form.telefone"
                      maxlength="20"
                      required
                      placeholder="Telefone"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-checkbox
                    id="checkbox"
                    v-model="form.status"
                    name="checkbox"
                    value="accepted"
                    unchecked-value="not_accepted"
                  >
                    Declaro ter lido e aceito integralmente os termos e condições da <a href="https://www.phonak.com/br/pt/privacy-policy.html" target="_blank">Declaração de Proteção de Dados do Grupo Sonova</a>
                  </b-form-checkbox>

                  <!-- <b-button pill variant="success">Enviar</b-button> -->
                  <b-button pill type="submit" variant="success" class="pull-right m-t-30 w-25 boldit enviar">Enviar</b-button>

                </b-form>
              </div>


          </div>

  </div>

</template>

<script>
import axios from 'axios';

export default {

  name: "Cadastre",

  data() {

      return {
        form: {
          nome: ''
        },
        show: true,
        utm_source: '',
        bg_image: require('../../assets/cadastre.png')
      }
    },
    created() {
      let urlParams = new URLSearchParams(window.location.search);
      let utm_source = urlParams.get('utm_source');

      this.utm_source = utm_source;
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault()

        if (!document.getElementById('checkbox').checked) {
          alert('É necessário aceitar os termos e condições.');
          return false;
        }

        document.getElementById('email_to_send').value = this.form.email

        //axios.post('http://localhost:3000/entry',{ params: { fname: this.fname, lname: this.lname, age: this.age }}).then(response => this.responseData = response.data).catch(error => {});


        const axios_config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }

        var bodyFormData = new FormData();
        bodyFormData.set('anuncio', 'teste auditivo');
        bodyFormData.set('nome', this.form.nome);
        bodyFormData.set('mail', this.form.email);
        bodyFormData.set('cep', this.form.cep);
        bodyFormData.set('tele', this.form.telefone);
        bodyFormData.set('redirecionar', '');
        bodyFormData.set('origem', this.utm_source);

        axios.post('https://www.phonakbr.com.br/leads/api.php', bodyFormData, axios_config)
        .then(response => {
          console.log(response.data)
        })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
        this.$router.push('page1')

      },
      onReset(evt) {
        evt.preventDefault()
        // Reset our form values
        this.form.nome = ''
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      },
      recaptcha() {
        this.$recaptcha('login').then((token) => {
          console.log(token) // Will print the token
        })
      }
    }
}
</script>

<style scoped>

#home {
  padding-top:35px;
  text-align: center;
}

.page-container #box {

}



@media only screen
  and (max-device-width: 599px) {
  .page-container {
    background-size: 100% !important;
  }
  .page-container .box {
    width: 100% !important;
    background-color: white;
    margin-top: 400px;
    padding: 0px 20px;
  }
  h1 {
    font-size: 2rem;
    text-align: center;
  }

  .enviar {
    width:100% !important;
    margin-bottom: 15px;
  }

}

</style>
